.Dialog {
  --dialog-grid: max-content auto max-content / auto;
  --dialog-margin: auto;
  --dialog-width: clamp(768px, 70vw, 1280px);
  --dialog-height: clamp(768px, 60dvh, 1024px);
  --dialog-padding: calc(var(--space-xxl) - 4px)
    calc(var(--space-xxl) * 2 - 12px);
  --backdrop-color: hsla(0, 0%, 0%, 0.4);
  --initial-transform: translateY(-3dvh) scale(0.98);
  --dialog-animation: show-dialog 500ms cubic-bezier(0.2, 1, 0.2, 1.04) forwards;

  container: dialog / size;
  outline: none;
  grid: var(--dialog-grid);
  margin: var(--dialog-margin);
  width: var(--dialog-width);
  height: var(--dialog-height);
  border: none;
  border-radius: var(--radius-xs);
  padding: var(--dialog-padding);
  box-shadow: var(--smooth-shadow);
  transform: var(--initial-transform);
  opacity: 0;

  &::backdrop {
    background: var(--backdrop-color);
    animation: fade-in 150ms ease forwards;
  }

  &[open] {
    display: grid;
    animation: var(--dialog-animation);
    opacity: 1;
    position: relative;
  }

  @media (max-width: 640px) {
    --initial-transform: none;
    --dialog-width: 100%;
    --dialog-height: auto;
    --dialog-margin: 0;
    --dialog-padding: var(--space);
    --dialog-animation: show-dialog-mobile 500ms cubic-bezier(0.2, 1, 0.2, 1.04)
      forwards;

    max-width: 100vw;
    max-height: 90%;
    margin-top: auto;

    & > * {
      animation: fade-in 300ms ease forwards;
    }
  }
}

@keyframes show-dialog {
  0% {
    opacity: 0.9;
  }

  100% {
    transform: none;
  }
}

@keyframes show-dialog-mobile {
  0% {
    top: 50dvh;
  }

  100% {
    top: 10dvh;
  }
}

@keyframes fade-in {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.DialogActions {
  --dialog-actions-grid: auto / 1fr max-content max-content;

  display: grid;
  grid: var(--dialog-actions-grid);
  padding: var(--space) 4px 4px;
  gap: var(--space-md);

  & > * {
    place-self: start;
  }
}

.DialogBody {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: var(--space) 4px 0;
  position: relative;
  overflow: auto;
}

.DialogCloseButton {
  --close-button-display: grid;

  cursor: pointer;
  user-select: none;
  display: var(--close-button-display);
  grid: auto / max-content auto;
  gap: var(--space-xs);
  align-items: center;
  position: absolute;
  top: var(--space-xs);
  left: var(--space-xs);
  border-radius: 2px;
  border: none;
  padding: var(--space-xs);
  font-size: 0.9375rem;
  font-weight: normal;
  color: var(--neutral);
  background: none;
  transition:
    color 250ms,
    background 250ms;

  &:not([disabled]):hover {
    color: var(--primary);
    background-color: var(--neutral-4);
  }

  [data-slot="icon"] {
    color: var(--primary);
  }

  &:focus-visible {
    outline-offset: 2px;
  }

  @media (max-width: 640px) {
    --close-button-display: none;
  }
}

.DialogHeader {
  position: relative;
  display: grid;
  grid: auto / auto max-content max-content;
  gap: var(--space-xl);
  padding: 4px 4px var(--space-md);

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 4px;
    right: 4px;
    height: 1px;
    background: var(--neutral-3);
  }
}
